import { useState } from "react";
import { Link } from "react-router-dom";
import { mangaList, categories } from "@/mocks/manga";
import MangaCard from "@/components/feature/MangaCard";

export default function DailyUpdateGrid() {
  const [activeCategory, setActiveCategory] = useState<string>("all");

  const filtered =
    activeCategory === "all"
      ? mangaList
      : mangaList.filter((m) => m.category === activeCategory);

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between mb-10 gap-4">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
              每日更新
              <span className="text-base md:text-lg font-sans text-foreground-500 ml-2 font-normal">· 全网最快</span>
            </h2>
            <p className="text-sm md:text-base text-foreground-500 max-w-xl">
              每日精选最新漫画章节，热门连载同步更新，再也不用担心错过每一话精彩内容。追更党必备！
            </p>
          </div>
        </div>

        {/* Category tabs */}
        <div className="flex items-center gap-2 mb-8 overflow-x-auto pb-2 flex-wrap">
          <button
            onClick={() => setActiveCategory("all")}
            className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all cursor-pointer ${
              activeCategory === "all"
                ? "bg-primary-500 text-white"
                : "bg-background-50 text-foreground-600 hover:bg-background-200 border border-background-200/70"
            }`}
          >
            全部
          </button>
          {categories.map((cat) => (
            <button
              key={cat.slug}
              onClick={() => setActiveCategory(cat.slug)}
              className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all cursor-pointer ${
                activeCategory === cat.slug
                  ? "bg-primary-500 text-white"
                  : "bg-background-50 text-foreground-600 hover:bg-background-200 border border-background-200/70"
              }`}
            >
              {cat.name}
            </button>
          ))}
        </div>

        {/* Cards grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-3 md:gap-4">
          {filtered.map((manga) => (
            <MangaCard
              key={manga.id}
              id={manga.id}
              title={manga.title}
              author={manga.author}
              description={manga.description}
              chapters={manga.chapters}
              status={manga.status}
              rating={manga.rating}
              views={manga.views}
              updateTime={manga.updateTime}
              imageUrl={manga.imageUrl}
              imageUrlThumb={manga.imageUrlThumb}
              variant="default"
            />
          ))}
        </div>

        {filtered.length === 0 && (
          <div className="text-center py-16">
            <i className="ri-emotion-sad-line text-4xl text-foreground-300 mb-3 block"></i>
            <p className="text-foreground-500">暂无该分类下的漫画</p>
          </div>
        )}

        <div className="mt-10 text-center">
          <Link
            to={activeCategory === "all" ? "/category/rexue" : `/category/${activeCategory}`}
            className="inline-flex items-center gap-2 px-6 py-3 bg-foreground-950 text-background-50 rounded-full text-sm font-medium hover:bg-foreground-800 transition-colors cursor-pointer whitespace-nowrap"
          >
            查看更多
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}